
// Bei jQuery Skripten, unbedingt importieren:
import $ from 'jquery';
import Dropzone from "dropzone";

const maxFilesNum = 10;
const maxFilesizeNum = 5;
const $dropzones = $('.dropzones');
var error =0;
if(document.querySelector('#restrictions')){
  document.querySelector('#restrictions').innerHTML= 'Bilder<sup>*</sup> ( Maximal '+maxFilesNum+' Dateien, maximal '+maxFilesizeNum+' Mb)';
}

if ($dropzones.length) {
  $dropzones.each((_, el) => {
    const dropzone = new Dropzone(el, {
      url: pluginUrl+'?type=35650&tx_uopinnwand_pinnwand%5Baction%5D=create&tx_uopinnwand_pinnwand%5Bcontroller%5D=Eintrag',

      // Translated dropzone messages
      dictDefaultMessage: "Dateien zum Hochladen hier ablegen",
      dictFallbackMessage: "Ihr Browser unterstützt keine Drag'n'Drop-Datei-Uploads.",
      dictFallbackText: "Bitte verwenden Sie das untenstehende Formular, um Ihre Dateien wie früher hochzuladen.",
      dictFileTooBig: "Datei ist zu groß ({{filesize}}MiB). Maximale Dateigröße: {{maxFilesize}}MiB.",
      dictInvalidFileType: "Sie können keine Dateien dieses Typs hochladen.",
      dictResponseError: "Der Server antwortete mit Statuscode {{statusCode}}",
      dictCancelUpload: "Upload abbrechen",
      dictCancelUploadConfirmation: "Sind Sie sicher, dass Sie diesen Upload abbrechen möchten?",
      dictRemoveFile: "Datei entfernen",
      dictMaxFilesExceeded: "Sie können keine weiteren Dateien hochladen.",
      autoProcessQueue: false,

      acceptedFiles: "image/*,application/pdf",
      addRemoveLinks: true,
      parallelUploads: 100,
      uploadMultiple: true,
      maxFiles: maxFilesNum,
      maxFilesize: maxFilesizeNum,
      clickable: '#dropzone',
      previewsContainer: '#dropzone',
      init: function() {
        var myDropzone = this;
        this.element.querySelector("input[type=submit]").addEventListener("click", function(e) {
          e.preventDefault();
          e.stopPropagation();

          var doUpload = true;
          var form = document.querySelector('#upload-form');
          for(var i=0; i < form.elements.length; i++){
            if(form.elements[i].value === '' && form.elements[i].hasAttribute('required')){
              form.elements[i].classList.add('is-invalid');
              displayMessage('Bitte die erforderlichen Felder ausfüllen.');
              $('html, body').stop().animate({scrollTop: 0 }, 1500);
              doUpload = false;
            }
          }
          if(doUpload){
            myDropzone.processQueue();
          }
        });
    
        // Listen to the sendingmultiple event. In this case, it's the sendingmultiple event instead
        // of the sending event because uploadMultiple is set to true.
        this.on("sendingmultiple", function() {
          // Gets triggered when the form is actually being sent.
          // Hide the success button or the complete form.
        });
        this.on("successmultiple", function(files, response) {
          // Gets triggered when the files have successfully been sent.
          // Redirect user or notify of success.
          data = JSON.parse(response);
          if(data.type === 'OK'){
            window.location.href = pluginUrl;
          }else{
            window.scrollTo(0, 0);
            window.location.reload();
            //displayMessage(data.message);
          }
        });
        this.on("errormultiple", function(files, response) {
          // Gets triggered when there was an error sending the files.
          // Maybe show form again, and notify user of error
          data = JSON.parse(response);
          displayMessage(data.message);

        });
        this.on("addedfile", file => {
          $('.dz-progress').hide();
        //   $submit.prop('disabled', true);
        });
      }
    });
  })
}

function displayMessage(msg){
  if(!error){
    error = 1;
    var li = document.createElement("li");
    li.classList.add('alert', 'alert-danger', 'alert-dismissible', 'fade', 'show');
    var p = document.createElement("p");
    p.classList.add('alert-message');
    var msg = document.createTextNode(msg);
    //var btn = document.createElement("button");
    //btn.classList.add('close');
    //btn.setAttribute("type", "button");
    //btn.setAttribute("data-dismiss", "alert");
    //var span = document.createElement("span");
    //span.innerHTML = '&times;';

    //btn.appendChild(span);
    //li.appendChild(btn);
    p.appendChild(msg);
    li.appendChild(p);
    msgbox.appendChild(li);
  }
}